import type { OperationVariables, TypedDocumentNode } from '@apollo/client';

import config from '../../../config';
import createClient from '../../../utils/create-apollo-client';
import getSanityUri from '../../../utils/get-sanity-uri';

async function getCmsData<TData, TVariables extends OperationVariables = OperationVariables>(
  query: TypedDocumentNode<TData, TVariables>,
  options?: { variables?: TVariables },
  dataset?: string,
  mode?: string,
): Promise<TData> {
  const variables = options?.variables;
  const sanityConfig = config.get('sanity');
  const sanityClient = createClient(
    config,
    sanityConfig.dataset,
    mode ?? 'published',
    getSanityUri(config, dataset, mode),
  );
  const result = await sanityClient.query<TData, OperationVariables, 'none'>({
    errorPolicy: 'none',
    query,
    variables,
  });

  return result.data;
}

export type CmsClient = typeof getCmsData;

export default getCmsData;
